import { RuleResult } from 'types/DeclarationP5'

const C0823Validator = {
  validateTransportEquipmentRequirement: ({
    containerIndicator,
  }: {
    containerIndicator?: string
  }): RuleResult => {
    if (containerIndicator === 'true') {
      return 'REQUIRED'
    }
    return 'OPTIONAL'
  },
} as const

export default C0823Validator
